var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLockAi = function SvgLockAi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.141,
    y: 7.809,
    width: 14.47,
    height: 10.858,
    rx: 3.278,
    stroke: "currentColor",
    strokeWidth: 1.435
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.6 5.389h1.428v2.506H5.6zM13.731 5.278h1.428v2.506h-1.428z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.606 5.48c0-1.1.439-2.162 1.233-2.983.795-.82 1.889-1.342 3.074-1.465a5.157 5.157 0 0 1 3.348.798c.972.638 1.892 2.335 1.893 3.448 0 0-1.424.743-1.424 0 0-.742-.608-1.925-1.294-2.375a3.641 3.641 0 0 0-2.364-.563 3.525 3.525 0 0 0-2.17 1.034 3.026 3.026 0 0 0-.87 2.106H5.605ZM9.528 9.786c.245-.667 1.189-.667 1.434 0l.612 1.665c.077.21.243.376.453.454l1.665.611c.667.245.667 1.19 0 1.434l-1.665.612a.764.764 0 0 0-.453.454l-.612 1.664c-.245.668-1.189.668-1.434 0l-.612-1.664a.764.764 0 0 0-.453-.454l-1.665-.612c-.668-.245-.668-1.189 0-1.434l1.665-.611a.764.764 0 0 0 .453-.454l.612-1.665Z",
    fill: "currentColor"
  })));
};
export default SvgLockAi;